import React from 'react';
import {createRoot} from 'react-dom/client';
import ConfigureProductForm from './ConfigureProductForm';

const ConfigureProductFormRoot = (props) => {
    const defaultProps = {
        ...props,
        trad: TRAD.ConfigureProductForm ?? {}
    }
    return <ConfigureProductForm {...defaultProps} />;
}

export default ConfigureProductFormRoot;

if(typeof window.configureProductFormRoots == 'undefined') {
    window.configureProductFormRoots = {};
}

// MOUNT/UNMOUNT OK
window.ConfigureProductFormRoot = function (sectionTag = 'global') {
    const elements = document.querySelectorAll('[data-react="configure-product-form"]');
    elements.forEach(element => {
        const uniqueId = element.dataset.windowId || sectionTag;

        if (window.configureProductFormRoots[uniqueId] && window.configureProductFormRoots[uniqueId].unmount) {
            window.configureProductFormRoots[uniqueId].unmount();
        }

        let attr = {
            sectionTag: sectionTag,
            windowId: uniqueId,
        };

        attr.date_start = element.dataset.date_start;
        attr.label_locations = element.dataset.label_locations;
        attr.label_dispositions = element.dataset.label_dispositions;
        attr.label_products_details = element.dataset.label_products_details;
        attr.label_hour_start = element.dataset.label_hour_start;
        attr.label_hour_end = element.dataset.label_hour_end;
        attr.label_modal_header = element.dataset.label_modal_header;

        attr.alert_function_sheets = element.dataset.alert_function_sheets;
        attr.hotels_id = element.dataset.hotels_id;
        attr.requests_hotels_id = element.dataset.requests_hotels_id;
        attr.products_type_slug = element.dataset.products_type_slug;
        attr.index = element.dataset.index;
        attr.client_lang = element.dataset.client_lang;

        attr.products_id = element.dataset.products_id;
        attr.has_functions_sheets = element.dataset.has_functions_sheets == 1;
        attr.display_calendar = element.dataset.display_calendar == 1;
        attr.base_current_url = element?.dataset?.base_current_url;

        const root = createRoot(element);
        root.render(<ConfigureProductFormRoot {...attr} />);

        window.configureProductFormRoots[uniqueId] = root;
    });
};
